<!-- filepath: fegridmaker/src/components/Sidebar.vue -->
<template>
  <div v-if="visible" class="sidebar-overlay" @click.self="close">
    <div class="sidebar-content">
      <button class="close-btn" @click="close">×</button>

      <div class="sidebar-toolbar">
        <button type="button" class="button-dark sidebar-action" @click="$emit('toggle-theme')">
          {{ isDarkMode ? '☀️ tema claro' : '🌙 tema escuro' }}
        </button>
        <button type="button" class="button-dark sidebar-action" @click="shutDown">🛑 desligar</button>
      </div>

      <div class="card-title">Hedge Infos</div>
      <hedgeTracker :calc-mode="false"/>

      <div class="card-title">Todays Kpis</div>
      <todayKpis />

    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import hedgeTracker from './hedgeTracker.vue'
import todayKpis from './todayKpis.vue'

export default {
  name: 'customSidebar',
  components: { hedgeTracker, todayKpis },
  computed: {
    ...mapState({
      kpis: state => state.kpis ? state.kpis : {pmpRegularUnits: 0, pmpManualUnits: 0, regularProfit: 0, rebuyProfit: 0}
    }),
  },
  props: {
    visible: { type: Boolean, required: true },
    isDarkMode: { type: Boolean, required: true },
  },
  emits: ['close', 'toggle-theme'],
  methods: {
    close() {
      this.$emit('close');
    },
    shutDown() {
      if (confirm('Tem certeza que deseja desligar o sistema?')) {
        const req = { type: 'shutDownSystem' };
        if (this.$store.state.socket) {
          this.$store.state.socket.send(JSON.stringify(req));
        }
      }
    },
  }
};
</script>

<style scoped>
.sidebar-overlay {
  position: fixed;
  top: 0;
  right: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0,0,0,0.2);
  z-index: 1000;
}
.sidebar-content {
  position: absolute;
  top: 0;
  right: 0;
  width: 500px;
  height: 100vh;
  background: var(--body-color, #fff);
  box-shadow: -2px 0 8px rgba(0,0,0,0.15);
  transition: right 0.3s;
  padding: 24px 18px;
  overflow-y: auto;
}
.close-btn {
  position: absolute;
  top: 12px;
  left: 12px;
  font-size: 22px;
  background: none;
  border: none;
  cursor: pointer;
  color: var(--text-color);
}

.sidebar-toolbar {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin: 0 0 8px 28px;
}

.sidebar-action {
  padding: 8px 12px;
  font-size: 13px !important;
}

.sidebar-profits {
    margin-top: 40px;
}

.sidebar-profits span {
    display: block;
}

.sidebar-profits strong {
    font-size: 1.8rem;
}


</style>
